import patch from "../../../patch";
import {UserChatState} from "../../../../entities/User";

const setChatsState = (user_ids: number[], state: UserChatState) =>
    patch(`chats`, {
        user_ids, state
    });

export default setChatsState;